<div class="form-group">
    <select class="select-form-control" [id]="depositeId" [(ngModel)]="selectedDeposit" [class.form-error]="hasError"
        value="" (change)="sendParentNotification($event)" (focus)="selectFirst()"
        [class.focused]="selectedFirst || getDeposit || selectedDeposit.depositNumber">
        <option style="direction: ltr;" *ngFor="let deposit of ownDepositList;let i= index" [ngValue]="deposit">
            <span style="font-family: 'novin_number'">{{deposit.depositNumber}} </span>
            <span>{{deposit?.depositType}} </span>
        </option>
    </select>
    <span class="floating-label">انتخاب سپرده مبدا</span>
    <span *ngIf="!optional" class="star">*</span>
    <span *ngIf="hasError" class="errorInput">پر کردن این فیلد الزامی است.</span>
    <span *ngIf="showTitle"
        style="display: block; margin-right: 5px; font-size: 13px; font-weight: normal;">{{selectedDeposit?.title}}
    </span>
</div>
